import { LoadingButton } from "@mui/lab";
import { Alert, Box, Container, TextField,IconButton, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../../features/authSlice";
import { SnackBarAlert } from "../../../utils/SnackBar";
import AnimatedPage from "../../animatedPage/AnimatedPage";
import { loginAndRegister, loginMember, verifyOtp } from "../auth.api";
import styles from "./styles.module.css";
import ForgotPasswordModal from "../ForgotPasswordModal/ForgotPasswordModal";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [phoneNumberSent, setPhoneNumberSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [alert, setAlert] = useState(false);
  const [user, setUser] = useState({
    email: "",
    password: 1,
  });
  const [showPass, setShowPass] = useState(false);
const EyeIcon = ({ visible }) =>
  visible ? (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ) : (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

  const handleCloseAlert = () => {
    setAlert(false);
  };

  function checkIfValidIndianMobileNumber(str) {
    // Regular expression to check if string is a Indian mobile number
    const regexExp = /^[6-9]\d{9}$/gi;

    return regexExp.test(str);
  }

  const usernameRef = useRef();
  const errRef = useRef();
  const otpRef = useRef();

  useEffect(() => {
    usernameRef.current.focus();
  }, []);

  const handleChnageInput = (e) => {
    const { name, value } = e.target;
    if (name && value) {
      setUser((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);
    loginMember(user)
      .then((res) => {
        if (res?.status === 200) {
          if(res?.data?.token){ 
            dispatch(login(res.data));
          } else {
            setAlert(res?.data?.message || "Login failed! Please contact the dev team.");
          }
          // console.log(res.data);
        } else {
          setAlert("Something went wrong!");
        }
      })
      .catch((err) => {
        setAlert("Something went wrong!");
        console.log(err);
      })
      .finally(() => setLoading(false));
  };
  return (
    <>
      {!showModal ? (
        <AnimatedPage>
          <Box className={styles.loginFormContainer}>
            <Typography
              color={grey[800]}
              style={{ margin: "16px 0" }}
              variant="h5"
              component={"p"}
            >
              Login
            </Typography>
            <form onSubmit={handleSubmit} className={styles.loginForm}>
              <TextField
                type={"email"}
                required
                onChange={handleChnageInput}
                inputRef={usernameRef}
                autoComplete="off"
                style={{ marginBottom: "10px" }}
                label="Email "
                name="email"
              />
              <TextField
                type={showPass ? "text" : "password"}
                required
                onChange={handleChnageInput}
                autoComplete="off"
                style={{ marginBottom: "10px" }}
                label="Password "
                name="password"
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={() => setShowPass((v) => !v)}
                      style={{ pointerEvents: "auto" }}
                    >
                      <EyeIcon visible={showPass} />
                    </IconButton>
                  ),
                }}
              />
              <div
                className="forgotPassword-btn"
                onClick={() => setShowModal(true)}
                type="button"
              >
                Forgot Password?
              </div>

              <ForgotPasswordModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
              />
              <LoadingButton
                type="submit"
                className={
                  loading
                    ? (styles.loginBtn, styles.loginBtnLoading)
                    : styles.loginBtn
                }
                sx={{
                  transition: "all 200ms ease-in-out",
                }}
                loading={loading}
                variant="contained"
              >
                Login
              </LoadingButton>
            </form>
            {/* <Typography
          align="right"
          mt={2}
          fontSize={14}
          className={styles.forgortLink}
        >
          Forgot Password?
        </Typography> */}
            <Typography
              align="right"
              fontSize={14}
              className={styles.forgortLink}
            >
              {/* <Link to={'/register'}>Sign up</Link> */}
            </Typography>
            <SnackBarAlert open={alert} handleClose={handleCloseAlert} />
          </Box>
        </AnimatedPage>
      ) : (
        <ForgotPasswordModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Login;
